<template>
  <div class="headNav van-fade-enter-active">
    <div class="head">
      <div class="mainContent">
        <img
          @click="getActive('Inicio')"
          class="logo"
          src="@/assets/img/fodown_one_1n.webp"
          alt=""
        />
        <div class="arrecredi_logo_ciew">
          <span style="color: #000000;"></span>
        </div>
        <ul class="nav">
          <li :class="activeNav == 'Inicio' ? 'active' : ''">
            <a @click="getActive('Inicio')">Inicio</a>
            <div class="line"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/nav.scss";

export default {
  name: "headNav",
  props: ["activeNav"],
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    getActive(val) {
      // this.activeNav = val;
      let url = "";
      switch (val) {
        case "Inicio":
          url = "/home";
          break;
        case "sobre":
          url = "/about";
          break;
        case "Aviso":
          url = "/notice";
          break;
        case "loan":
          url = "/loan";
          break;
        case "ayuda":
          url = "/help";
          break;
      }
      this.$router.push(url);
    },
  },
};
</script>

<style>
</style>
